<template>
  <div class="flex items-center" @click="$emit('input', !value)">
    <!-- Enabled: "bg-blue-600", Not Enabled: "bg-gray-200" -->
    <button type="button" :class="value && '!bg-blue-600'" class="bg-gray-200 relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" role="switch" aria-checked="false" aria-labelledby="annual-billing-label">
      <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
      <span aria-hidden="true" :class="value ? 'translate-x-5' : 'translate-x-0'" class="translate-x-0 pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
    </button>
    <span class="ml-3 text-sm">Enable</span>
  </div>
</template>

<script>

export default {
  props: ['value']
}

</script>
